import { render } from "./ApplicationsProfileComponent.vue?vue&type=template&id=2f0a2c00&scoped=true&ts=true"
import script from "./ApplicationsProfileComponent.vue?vue&type=script&lang=ts"
export * from "./ApplicationsProfileComponent.vue?vue&type=script&lang=ts"

import "./ApplicationsProfileComponent.vue?vue&type=style&index=0&id=2f0a2c00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0a2c00"]])

export default __exports__